export const GET_PEOPLE_DATA = "GET_PEOPLE_DATA" 
export const GET_FEED_DATA = "GET_FEED_DATA" 
export const GET_CHANGE_DATA = "GET_CHANGE_DATA" 